export const COPY = {
  sublineHome:
    "From dream holidays to tuition fees and essential healthcare, Flexaura turns large costs into simple monthly plans with every financing option in one trusted marketplace.",
  sublineByVertical: {
    travel:
      "Book flights, hotels, and packages with flexible finance",
    education:
      "Pay school and university fees in manageable monthly installments",
    healthcare:
      "Finance essential and elective treatments without the stress",
  },
  footerTagline: "Milestone moments, manageable payments",
  trustSection: {
    title: "Backed by trusted names in finance",
    subtitle: "More partners launching soon"
  },
  howItWorks: {
    title: "How It Works",
    steps: [
      {
        title: "Pick your journey",
        description: "Travel, healthcare, home improvement and more"
      },
      {
        title: "Compare your options",
        description: "See Tabby, Tamara, Cashew and more side by side — real monthly amounts, zero hidden fees"
      },
      {
        title: "Pay monthly",
        description: "Complete your booking and activate your payment plan instantly"
      }
    ]
  },
  whyFlexaura: {
    title: "Why Flexaura",
    reasons: [
      {
        title: "One place, every option",
        description: "No more juggling multiple apps or banks"
      },
      {
        title: "Transparent and trusted",
        description: "See the true cost of BNPL, EMI, and extended finance before you decide"
      },
      {
        title: "Built for life milestones",
        description: "Travel, tuition, healthcare, not just impulse shopping"
      },
      {
        title: "5 providers, one checkout",
        description: "Compare Tabby, Tamara, Cashew, Postpay and Spotii in a single screen. No switching apps."
      }
    ]
  },
  closing: {
    title: "Milestone moments, manageable payments",
    description: "Flexaura brings BNPL options and bank instalment (EPP) comparison into one platform.",
    cta: "Get Early Access"
  }
};

export type VerticalKey = keyof typeof COPY.sublineByVertical; // 'travel' | 'education' | 'healthcare'